const URL_API = process.env.REACT_APP_API_ROOT_URL || "http://localhost:4066";

const URL_MARKETPLACE = process.env.REACT_APP_MARKETPLACE_URL || "http://localhost:5001";

const URL_REALTIME = process.env.REACT_APP_REALTIME_URL || "ws://localhost:4088";

export const BASE_URL = URL_API ;

export const BASE_URL_MARKETPLACE = URL_MARKETPLACE ;

export const BASE_URL_REALTIME = URL_REALTIME;

export const BASE_URL_API = `${URL_API}/api/graphql`;

export const BASE_URL_UPLOAD = `${URL_API}/api/uploadImage`;

export const BASE_URL_UPLOAD_FILE = `${URL_API}/api/uploadFile`;

export const URL_END_POINT = `${URL_API}/api/upload/drug`;

export const BASE_URL_API_NEW = `${URL_MARKETPLACE}/api/graphql`;

export const URL_IMPORT_USER_REMOVE = `${URL_API}/api/upload/importUserRemove`;

export const BIZ_MBS = JSON.parse(process.env.REACT_APP_BIZ_MBS) || [];

export const BIZ_MBS_TEMSTAFF = JSON.parse(process.env.REACT_APP_BIZ_MBS_TEMSTAFF) || [];

export const EXCLUDED_MIGRATE_USER_BUSINESS_ID = JSON.parse(process.env.REACT_APP_EXCLUDED_MIGRATE_USER_BUSINESS_ID) || [];